export default __webpack_public_path__ + "static/nobs-4c98675233190025fb9305b5017924b1.png";